import { createTheme } from '@mui/material/styles';

// First define the palette,
// then use composition to create the rest
// of the theme, giving us access to the palette
// that we define.
let theme = createTheme({
  // Custom theme properties go here.
  // See https://mui.com/customization/theming/#theme-configuration-variables
  palette: {
    mode: 'light',
    primary: {
      main: '#112334',
      contrastText: '#fff',
    },
    secondary: {
      main: '#2C5877',
      contrastText: '#fff',
    },
    tertiary: {
      main: '#62B0DC',
      contrastText: '#fff',
    },
    dashboard: {
      bulkCancel: '#D52D34',
    },
    sidebarContent: {
      main: '#222E3B',
      labelText: '#AEB1B4',
      valueText: '#FFFFFF',
      cancel: '#D52D34',
      disabled: '#ADADAD',
    },
    error: {
      main: '#D52D34',
      withOpacity: 'rgba(213, 45, 52, .15)',
    },
    success: {
      main: '#52B35B',
      withOpacity: 'rgba(82, 179, 91, .15)',
    },
    warning: {
      main: '#EAAB00',
      withOpacity: 'rgba(234, 171, 0, .15)',
    },
    info: {
      main: '#55A7DF',
      withOpacity: 'rgba(85, 167, 223, .15)',
    }
  },
});

// using composition allows us to access the
// theme variables that have already been defined
// such as palette colors.
theme = createTheme(theme, {
  typography: {
    htmlFontSize: 14,
    fontFamily: [ '-apple-system', 'BlinkMacSystemFont', '"Open Sans"', 'sans-serif' ].join(','),
  },
  components: {
    // None yet
  },
});

export { theme };
